import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FEATURE_NAME } from './constants';
import { ModalsState } from 'src/redesign/features/Modals/types';

const initialState: ModalsState = {
  currentModal: null,
  visible: false,
  data: null,
};

export const modalsSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    setCurrentModal: (state, action: PayloadAction<ModalsState>) => {
      state.currentModal = action.payload.currentModal;
      state.data = action.payload.data;
      state.visible = true;
    },
    closeCurrentModal: (state) => {
      state.visible = false;
      // setTimeout(() => {
      state.data = null;
      state.currentModal = null;
      state.visible = false;
      // }, 1000);
    },
  },
});

export const setCurrentModalAction = modalsSlice.actions.setCurrentModal;
export const closeCurrentModalAction = modalsSlice.actions.closeCurrentModal;
